<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-16 09:39:27
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-16 11:04:27
 * @name: 延期审批
 * @Description: 延期审批
 * @FilePath: \preSaleNafterSaleInside\project\src\views\index\delay\delayRouter.vue
 * @Author: desktop
-->
<template>
  <div>

  </div>
</template>
<script>
export default {
  name: 'indexDelay',
}
</script>
<style lang="scss" scoped>

</style>